document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener("scroll", updateViewCollection);
    let originalTitle = document.title;
    let originalURL = window.location.href;

    let collectionItems = {};

    function updateViewCollection() {
        if (Object.keys(collectionItems).length > 0) {
            let visibleElement = null;

            for (let el of collectionItems) {
                if (el.positionTop <= window.scrollY && el.positionBottom >= window.scrollY) {
                    visibleElement = el;
                    break;
                }
            }

            if (visibleElement) {
                if (visibleElement.url !== originalURL) {
                    document.title = visibleElement.title;
                    window.history.replaceState(null, '', visibleElement.url);
                }
            } else {
                document.title = originalTitle;
                window.history.replaceState(null, '', originalURL);
            }
        }
    }

    const sectionCollectionItems = document?.querySelector('.collection--items');
    let collectionJSON = '';

    if (document?.querySelector("#collection-json")) {
        collectionJSON = JSON.parse(document?.querySelector("#collection-json").innerHTML) || false;
    }

    window.addEventListener('scroll', scrollHandler);

    function scrollHandler() {
        let documentHeight = document.body.offsetHeight - 400;
        let windowScrollHeight = window.innerHeight + window.scrollY;

        if (windowScrollHeight >= documentHeight && Object.keys(collectionJSON.collections).length !== 0) {
            let collectionLoadMore = document?.querySelector('.collection-load-more');
            renderMoreCollections(collectionJSON, collectionLoadMore);
            window.removeEventListener('scroll', scrollHandler);
        }
    }

    function renderMoreCollections(collectionJSON, collectionLoadMore) {
        fetch(collectionJSON.collections[0].collection_url)
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();
                let parsedHTML = parser.parseFromString(data, 'text/html');
                let createdElement = document.createElement('div');
                let collectionGrid = parsedHTML.querySelector('.product-grid-container');
                let description = parsedHTML.querySelector('.collection-hero__description');
                createdElement.classList.add('collection-item');
                
                let collectionTitle =
                    `<div data-collection-url="${collectionJSON.collections[0].collection_url}"
                      data-collection-title="${collectionJSON.collections[0].collection_title}"
                      class="collection-hero">
                    <div class="collection-hero__inner page-width">
                        <div class="collection-hero__text-wrapper">
                            <h1 class="collection-hero__title">${collectionJSON.collections[0].collection_title}</h1>
                            <div class="collection-hero__description">
                            ${ description ? description.innerHTML : ''}
                            </div>
                        </div>
                    </div>
                </div>`;

                let tempContainer = document.createElement('div');
                tempContainer.innerHTML = collectionTitle;

                createdElement.appendChild(tempContainer.firstChild);
                createdElement.appendChild(collectionGrid);
                sectionCollectionItems.appendChild(createdElement);
                document.querySelector('.collection-load-more').remove();
                collectionLoadMore.querySelector('.collection-load-more__title').innerHTML = collectionJSON?.collections[1]?.collection_title ? collectionJSON.collections[1].collection_title : document.querySelector('.collection-load-more').remove();
                sectionCollectionItems.appendChild(collectionLoadMore);
                collectionJSON.collections.shift();

                let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                if (isSafari) {
                    let collectionItemsImages = document?.querySelectorAll('.collection-item .card__inner .card__media img');
                    collectionItemsImages.forEach((image) => {
                        let urlObject = new URL(image.src);
                        let width = +urlObject.searchParams.get("width") + 1;
                        let newWidth = width.toString();
                        urlObject.searchParams.set("width", newWidth);
                        image.src = urlObject
                    });
                }

                collectionItems = Array.from(document.querySelectorAll('.collection-item')).map(el => ({
                    url: el.querySelector('.collection-hero').dataset.collectionUrl,
                    title: el.querySelector('.collection-hero').dataset.collectionTitle,
                    positionTop: el.offsetTop,
                    positionBottom: el.offsetTop + el.offsetHeight
                }));
                readMore();
                window.addEventListener('scroll', scrollHandler);
            })
            .catch(e => {
                console.error(e);
            });
    }

    function readMore(){
      const readMoreElements = document.querySelectorAll('.collection-hero__triger');
      
      readMoreElements.forEach(readMoreElement => {
        if (!readMoreElement.hasAttribute('data-event')) {
          readMoreElement.setAttribute('data-event', 'true');
          const collectionDescription = readMoreElement.nextElementSibling;
          const hiddenTrigger = collectionDescription.nextElementSibling;
      
          if (collectionDescription && hiddenTrigger) {
            readMoreElement.addEventListener('click', function(){
              collectionDescription.classList.remove('hidden');
              readMoreElement.classList.add('hidden');
              readMoreElement.previousElementSibling.classList.add('hidden');
              hiddenTrigger.classList.remove('hidden');
            });
            hiddenTrigger.addEventListener('click', function(){
              collectionDescription.classList.add('hidden');
              readMoreElement.classList.remove('hidden');
              readMoreElement.previousElementSibling.classList.remove('hidden');
              hiddenTrigger.classList.add('hidden');

            });
          }
        }

      });
    }
    readMore();
});